import * as yup from "yup";

export const RequestPasswordResetFormSchema = yup.object({
  email: yup.string().required("Please fill in your registered email").email("Please fill in a valid email"),
});

export type RequestPasswordResetFormSchema = yup.InferType<typeof RequestPasswordResetFormSchema>;
